import React from 'react';
import cx from 'classnames';
import Modal from '../../../../../components/Modal/Modal';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import InfoTable from '../../../../../components/table/InfoTable';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import { setDash, setPhoneFormat, setNumberWithComma } from '../../../../../lib/common';
import {
  MAXIMUM_NUMBER_OF_POINT_MEMO_TEXT,
  POINT_CAUSE_REFUND_INDEX,
  POINT_LOG_TYPE,
  POINT_LOG_TYPE_TEXT,
} from '../../../../../constants/service/app/pointConstants';
import './GeneratePointValidSuccessModal.scss';

const GeneratePointValidSuccessModal = (props) => {
  const { isOpen, data, form, memo, setData, onSubmit, closeModal } = props;
  const { requestCnt, possibleCnt, impossibleCnt, userPointList, pointCauseSelectList } = data;

  return (
    <Modal
      title="포인트 발급"
      isOpen={isOpen}
      width={1550}
      height={600}
      isFooter={true}
      okText="발급하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="generate-point-valid-success-modal-wrap">
        <div className="generate-point-valid-success-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>모든 요청이 포인트 발급이 가능합니다.</div>
          <div>발급할때 적을 메모가 있다면 아래 칸에 적어주세요.</div>
        </div>

        <div className="generate-point-valid-success-memo">
          <TextAreaForm
            form={form}
            label={
              <span>
                <span>메모</span>
                <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_POINT_MEMO_TEXT} />
              </span>
            }
            initialValue={memo}
            placeholder="메모할 내용을 적어주세요."
            maxLength={MAXIMUM_NUMBER_OF_POINT_MEMO_TEXT}
            onChange={(value) =>
              setData({
                name: 'memo',
                value,
              })
            }
            name="memo"
            rows={2}
          />
        </div>

        <div className="generate-point-valid-success-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>회원 번호</th>
                <th>이름</th>
                <th>휴대전화 번호</th>
                <th>내역 종류</th>
                <th>적립/사용처</th>
                <th>
                  적용 전 <br /> 사용가능한 포인트
                </th>
                <th>
                  적용 전 <br /> 누적된 총 사용 포인트
                </th>
                <th>입력한 액수</th>
                <th>
                  적용 후 <br /> 사용가능한 포인트
                </th>
                <th>
                  적용 후 <br /> 누적된 총 사용 포인트
                </th>
              </tr>
            </thead>
            <tbody>
              {userPointList.map((item, index) => (
                <tr key={index}>
                  <td className="tc">
                    <OpenUserDetail text={item.userId} userId={item.userId} />
                  </td>
                  <td className="tc">{setDash(item.name)}</td>
                  <td className="tc">{setPhoneFormat(item.cellPhone)}</td>
                  <td className="tc">{POINT_LOG_TYPE_TEXT[item.type]}</td>
                  <td className="tc">
                    {item.pointCauseId
                      ? pointCauseSelectList.find((causeItem) => causeItem.id === item.pointCauseId).name
                      : null}
                  </td>
                  <td className="tc">{setNumberWithComma(item.pointAmount)}</td>
                  <td className="tc">{setNumberWithComma(item.usedPointAmount)}</td>
                  <td className="tc amount">{setNumberWithComma(item.amount)}</td>
                  <td className="apply">{setNumberWithComma(item.afterPointAmount)}</td>
                  {/*타입이 사용일때 + cause 가 5 일때는 usedCredit 의 변화가 있다.*/}
                  <td
                    className={cx({
                      apply: item.type === POINT_LOG_TYPE.USE || item.pointCauseId === POINT_CAUSE_REFUND_INDEX,
                    })}
                  >
                    {setNumberWithComma(item.afterUsedPointAmount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default GeneratePointValidSuccessModal;
